import { useState } from "react";

export default function AdminPanel() {
  const [auth, setAuth] = useState("");
  const [unlocked, setUnlocked] = useState(false);
  const [tenantName, setTenantName] = useState("");
  const [codeTenantName, setCodeTenantName] = useState("");
  const [codeCount, setCodeCount] = useState(1);
  const [codes, setCodes] = useState([]);
  const [message, setMessage] = useState("");

  const handleUnlock = () => {
    if (auth === "supersecretadminpass") setUnlocked(true);
  };

  const createTenant = async () => {
    try {
      const res = await fetch("/admin/create-tenant", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
          name: tenantName,
          secret: auth
        })
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.error || "Błąd tworzenia tenanta");
      }

      const data = await res.json();
      setMessage(`Tenant utworzony: ${data.tenant.name}`);
    } catch (err) {
      setMessage(err.message || "Błąd");
    }
  };

  const generateCodes = async () => {
    try {
      const res = await fetch("/admin/generate-invites", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
          tenantName: codeTenantName,
          count: codeCount,
          secret: auth
        })
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.error || "Błąd generowania kodów");
      }

      const data = await res.json();
      setCodes(data.codes);
    } catch (err) {
      setMessage(err.message || "Błąd");
    }
  };

  if (!unlocked) {
    return (
      <div style={{ padding: 40 }}>
        <h2>Admin access</h2>
        <input
          type="password"
          placeholder="Podaj hasło"
          value={auth}
          onChange={(e) => setAuth(e.target.value)}
        />
        <button onClick={handleUnlock}>Zatwierdź</button>
      </div>
    );
  }

  return (
    <div style={{ padding: 40 }}>
      <h1>Admin Panel</h1>
      {message && <p>{message}</p>}

      <div style={{ marginBottom: 30 }}>
        <h3>➕ Dodaj Tenanta</h3>
        <input
          value={tenantName}
          onChange={(e) => setTenantName(e.target.value)}
          placeholder="Nazwa tenanta"
        />
        <button onClick={createTenant}>Dodaj</button>
      </div>

      <div>
        <h3>🎟️ Wygeneruj Invite Code’y</h3>
        <input
          value={codeTenantName}
          onChange={(e) => setCodeTenantName(e.target.value)}
          placeholder="Nazwa tenanta"
        />
        <input
          type="number"
          min={1}
          value={codeCount}
          onChange={(e) => setCodeCount(parseInt(e.target.value))}
        />
        <button onClick={generateCodes}>Generuj</button>
      </div>

      {codes.length > 0 && (
        <div style={{ marginTop: 20 }}>
          <h4>Wygenerowane kody:</h4>
          <pre>{codes.join("\n")}</pre>
        </div>
      )}
    </div>
  );
}
